export default __webpack_public_path__ + "static/media/html.ff3cf75e.png";